import React, { PureComponent } from "react";
import { Col } from "antd";
import PropTypes from "prop-types";

import Viewer from "react-viewer";
import "react-viewer/dist/index.css";

const MEDIA_DOWNLOAD_URL = process.env.REACT_APP_API + "/api/media/downloadbyurl/";
const AWS_URL = "https://s3-eu-west-1.amazonaws.com/surveyefficiencecell/";
function forceDownload(url, fileName) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function() {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
}

class Photo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  render() {
    let { media, visit_end_date, pdc_label } = this.props;
    const mediaContent = media || {};
    const mediaContentResponse = mediaContent.response || {};
    const mediaContentResponseUrl = mediaContentResponse.url || "";
    const mediaUrlThumbnail = mediaContentResponse.urlResized || mediaContentResponse.url || "";

    const endDateAsString = visit_end_date || "";
    const endDate = new Date(endDateAsString);

    const date =
      endDate.getUTCFullYear() +
      "/" +
      ("0" + (endDate.getUTCMonth() + 1)).slice(-2) +
      "/" +
      ("0" + endDate.getUTCDate()).slice(-2) +
      " " +
      ("0" + endDate.getUTCHours()).slice(-2) +
      ":" +
      ("0" + endDate.getUTCMinutes()).slice(-2) +
      ":" +
      ("0" + endDate.getUTCSeconds()).slice(-2);

    return (
      <Col span={5} className="p-phototheque-item">
        <div className="p-phototheque-item-container">
          <div className="p-phototheque-item-photo-container">
            <img
              onClick={() => {
                this.setState({
                  visible: true
                });
              }}
              class="photoswipe-gallery"
              className="p-phototheque-item-photo"
              src={AWS_URL + mediaUrlThumbnail}
            />

            <Viewer
              visible={this.state.visible}
              drag={true}
              noClose={false}
              rotatable={true}
              scalable={true}
              downloadable={false}
              onMaskClick={() => {
                this.setState({ visible: false });
              }}
              onClose={() => {
                this.setState({ visible: false });
              }}
              customToolbar={toolbars => {
                return toolbars.concat([
                  {
                    key: "download_custom",
                    render: (
                      <li className="react-viewer-btn" data-key="download">
                        <i className="react-viewer-icon react-viewer-icon-download" />
                      </li>
                    ),
                    onClick: activeImage => {
                      forceDownload(activeImage.downloadUrl, activeImage.name + ".jpg");
                    }
                  }
                ]);
              }}
              images={[
                {
                  src: AWS_URL + mediaContentResponseUrl,
                  alt: "",
                  downloadUrl: MEDIA_DOWNLOAD_URL + mediaContentResponseUrl,
                  name: `${pdc_label} ${date.replace("/", "_")}`
                }
              ]}
            />
          </div>
        </div>
      </Col>
    );
  }
}

Photo.propTypes = {
  media: PropTypes.object,
  checked: PropTypes.bool
};

export default Photo;



// WEBPACK FOOTER //
// src/components/visit/PhotoVisit.js